import { render, staticRenderFns } from "./Err404.vue?vue&type=template&id=12ed737b&scoped=true&"
import script from "./Err404.vue?vue&type=script&lang=js&"
export * from "./Err404.vue?vue&type=script&lang=js&"
import style0 from "./Err404.vue?vue&type=style&index=0&id=12ed737b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ed737b",
  null
  
)

export default component.exports